"use strict";


function makeChatIframe(chatListRoute)
{
    var teameoChat = document.getElementById('teameo-chat');
    if(null !== teameoChat){
        document.getElementById('teameo-chat').remove();
    }


    var iframe = document.createElement('iframe');
    iframe.setAttribute('border', 0);
    iframe.id = 'teameo-chat';
    iframe.src = chatListRoute;
    iframe.textContent = ' Messages are loading...';


    document.querySelector('body').prepend(iframe);
}


$(document).ready(function(){
    $('body').on('click', '.open-chat-window', function(e){
        var u = $(this).data('createchaturl')+'?match_id='+ $(this).data('matchid');

        $.get(u, function(response){
            var jsonResponse = JSON.parse(response);
            makeChatIframe(jsonResponse.chat_list_route);
        })
    });
});
